import type { OrderType } from '../order-type/order-type.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class OrderTypeFactory extends ObjectFactory<OrderType> {
  protected getDefaults(): OrderType {
    return {
      ...baseDocumentFactory.build(),
      code: 'standard',
      isSystemic: false,
      label: 'Standard',
    };
  }
}

export const orderTypeFactory = new OrderTypeFactory();
